import styled from 'styled-components'

const MapPinContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 22px;
  height: 22px;
  transform: translate(-50%, -50%);
`

export { MapPinContainer }
